import React, { Component } from "react";
import "./Welcome.scss";

export default class Welcome extends Component {
    constructor() {
        super();
        this.state = {}
    }
    render() {
        return (
            <section className="section section-welcome">
                <div className="w-padding">
                    <div className="w-container">
                        <div className="logo"><a href="https://www.frogi.co.il/" title="פרוגי" target="_blank">
                        </a>
                        </div>
                        <div className="headline">
                            ענו על החידון ותוכלו לזכות בכרטיס זוגי
    להופעה ומפגש מאחורי הקלעים עם
                        </div>
                       
                    </div>
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Welcome/Welcome.jsx